module.exports = __webpack_public_path__ + "img/51.199ebd75.png";